<template>
<!-- this picker could be used as two level picker: 
    territory picker, then user picker
    OR, just use as territory picker 
    logic: if repTypeToPick has value, it is two levels picker, otherwise, one level -->
    <div>
        <v-card>
            <v-card-text>
                <h3>Pick a Territory</h3>
                <v-chip v-for="terr in terrs" :key="terr.id"
                 @click="onTerrPicked(terr)"
                 :color="terr.id == selectedTerrId? 'green' : 'gray'" 
                 >{{terr.id}}</v-chip>
            </v-card-text>
            <v-card-text v-if="repTypeToPick=='salesRep'">
                <h3>Pick a Sales Rep</h3>
                <v-chip v-for="rep in salesReps" :key="rep.id"
                    color="gray" 
                    @click="$emit('on-rep-picked', rep)">{{rep.name}}</v-chip>
            </v-card-text>
            <v-card-actions class="white hide">
                <v-spacer></v-spacer>
                <v-btn color="warning" @click="$emit('hide-territoryxrep-picker')">Cancel</v-btn>
            </v-card-actions>
        </v-card>
        <!-- {{salesReps}} -->
    </div>
</template>
<script>
export default {
    props: ['terrs', 'repTypeToPick'],
    data() {
        return {
            selectedTerrId: null,
        }
    },
    computed: {
        salesReps() {
            if(this.selectedTerrId) {
                var terr = this.terrs.find(o=>o.id == this.selectedTerrId)
                return terr.salesReps
            }
            return []
        },
    },
    methods: {
        onTerrPicked(terr) {
            //use as two level pciker
            if(this.repTypeToPick) {
                this.selectedTerrId = terr.id
            } else {    //use a one level: terr picker
                this.$emit('on-terr-picked', terr.id)
            }

        }
    },
}
</script>